import { render, staticRenderFns } from "./loginForm.vue?vue&type=template&id=77f6e8c2&"
import script from "./loginForm.vue?vue&type=script&lang=ts&"
export * from "./loginForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports